var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsNewActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3555_280777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.44445 19.3328L4.93209 18.29C1.75919 19.5329 0.527975 23.151 2.25284 26.0768C3.30466 28.3275 6.04973 29.5439 8.42634 28.8141C8.87418 28.696 9.3646 28.4353 9.78339 28.2314C9.6595 27.9933 5.71612 19.8884 5.44445 19.3322V19.3328Z",
    fill: "#4E84C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5729 22.1117C32.5562 21.8729 32.4878 21.6393 32.3864 21.4245H32.3806L23.9596 4.14936C23.7989 3.81059 23.5363 3.52795 23.2259 3.32791C21.4984 2.22962 19.3993 4.08677 20.2963 5.93747L20.4189 6.19365C18.1391 9.07358 15.7102 12.171 12.7251 14.3766C12.2088 14.8451 6.70255 17.3888 5.98047 17.7779C6.70965 19.2505 10.1026 26.2467 10.8318 27.7199C12.0714 27.123 14.2828 26.0383 15.5437 25.4253C16.0735 25.1717 16.8401 24.7613 17.4073 24.5864C21.079 23.4849 25.0882 23.5088 28.8754 23.4739C29.1884 23.9398 29.7091 24.2386 30.2557 24.3302C30.2234 24.3244 30.1899 24.3141 30.157 24.307C31.485 24.5935 32.7259 23.4539 32.5742 22.1111L32.5729 22.1117Z",
    fill: "#4E84C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1045 25.9614C15.8552 26.5732 13.6419 27.6502 12.3926 28.2619L15.1996 34.016C15.4035 34.4354 15.7584 34.7497 16.2011 34.9013C16.6418 35.0549 17.1129 35.031 17.5349 34.82L19.1075 34.0573C19.5269 33.8533 19.8412 33.4984 19.9928 33.0558C20.1445 32.6131 20.1154 32.1414 19.9115 31.7219L17.1045 25.9621V25.9614Z",
    fill: "#4E84C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7419 12.0201C29.8832 12.3118 30.2375 12.4279 30.5208 12.2885L34.1847 10.5011C34.4738 10.3598 34.5938 10.0113 34.4525 9.72222C34.3119 9.43378 33.966 9.31311 33.6737 9.45378L30.0097 11.2412C29.7206 11.3826 29.6006 11.731 29.7419 12.0201Z",
    fill: "#4E84C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9738 8.10356C28.2577 8.23972 28.6114 8.11969 28.7488 7.82608L30.3446 4.45573C30.4827 4.16535 30.3582 3.81753 30.0678 3.68009C29.7787 3.54264 29.4309 3.66654 29.2928 3.95756L27.697 7.32792C27.5589 7.6183 27.6834 7.96611 27.9738 8.10356Z",
    fill: "#4E84C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0732 16.2012L32.435 15.3836C31.6768 15.2436 31.4323 16.3212 32.1802 16.52L35.8183 17.3375C36.1235 17.4085 36.4449 17.213 36.5139 16.8968C36.5843 16.5826 36.3868 16.2715 36.0732 16.2012Z",
    fill: "#4E84C4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3555_280777"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.058,
    height: 32,
    fill: "white",
    transform: "translate(1.4707 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsNewActive);
export default __webpack_public_path__ + "static/media/WhatsNew_active.ecd05695ccd0603a63b09701a6afb601.svg";
export { ForwardRef as ReactComponent };